var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getCreate2Address } from '@ethersproject/address';
import { keccak256, pack } from '@ethersproject/solidity';
import { CurrencyAmount, Ether, Fraction, JSBI, Token } from '@sushiswap/sdk';
import { FACTORY_ADDRESS, INIT_CODE_HASH } from '@sushiswap/sdk';
import IUniswapV2Router02Json from '@uniswap/v2-periphery/build/IUniswapV2Router02.json';
import uniswapV2PairContract from '../../../../abis/uniswapV2PairContract.json';
import { ethers } from 'ethers';
import { getAddress } from 'ethers/lib/utils';
import { Config } from '../../../../Fct/Config';
import { currencyToWei } from '../../../../Fct/helpers';
import { getPlugin } from '../../../../Fct/plugins/helpers';
import { getMethodName } from '../../../../Fct/plugins/uniswap/helpers/getMethodName';
import { UNISWAP_TYPE } from '../../../../Fct/plugins/uniswap/helpers/Uniswap';
import { WETH } from 'simple-sushiswap-sdk';
import { weiToCurrency } from '../../../../utils/tryParseCurrencyAmount';
import { SUSHISWAP_ROUTER_ADDRESS } from '../constants';
import { Sushiswap as SushiswapPlugins } from '../Sushiswap';
import getClientSideSmartOrderRouterTrade from './getClientSideSmartOrderRouterTrade';
import getSlippage from './getSlippage';
import { getSwapCall } from './getSwapCall';
import { Field } from './types/swap';
import { TradeState } from './types/types';
var IUniswapV2Router02ABI = IUniswapV2Router02Json.abi;
var INVALID_TRADE = { state: TradeState.INVALID, trade: undefined };
var getMinAmount = function minimumAmountOut(amount, slippageTolerance, currency) {
    var slippageAdjustedAmountOut = new Fraction(JSBI.BigInt(1))
        .add(slippageTolerance)
        .invert()
        .multiply(amount).quotient;
    return CurrencyAmount.fromRawAmount(currency, slippageAdjustedAmountOut);
};
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
var Sushiswap = /** @class */ (function (_super) {
    __extends(Sushiswap, _super);
    function Sushiswap() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.promiseReject = undefined;
        _this.getSwapParams = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var values, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.setLastInputValuesV2({ input: input, output: output })];
                        case 1:
                            values = _b.sent();
                            return [2 /*return*/, values];
                        case 2:
                            e_1 = _b.sent();
                            if (e_1 === REJECT_PREV_REQUEST_ERROR) {
                                return [2 /*return*/, undefined];
                            }
                            throw new Error(e_1);
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getPairAddress = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            var pairAddress = getCreate2Address(FACTORY_ADDRESS[_this.chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH[_this.chainId]);
            return pairAddress;
        };
        _this.isPairExist = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var pairAddress, contract, e_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pairAddress = this.getPairAddress({ token0: token0, token1: token1 });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            contract = new ethers.Contract(pairAddress, uniswapV2PairContract, this.library);
                            return [4 /*yield*/, contract.factory()];
                        case 2:
                            _b.sent();
                            return [2 /*return*/, true];
                        case 3:
                            e_2 = _b.sent();
                            console.error({ error: e_2 });
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getPathAmountOut = function (_a) {
            var amountIn = _a.amountIn, path = _a.path;
            return __awaiter(_this, void 0, void 0, function () {
                var contract, res, e_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            contract = new ethers.Contract(SUSHISWAP_ROUTER_ADDRESS[String(this.chainId)], IUniswapV2Router02ABI, this.library);
                            return [4 /*yield*/, contract.getAmountsOut(amountIn, path)];
                        case 1:
                            res = (_b.sent());
                            return [2 /*return*/, res];
                        case 2:
                            e_3 = _b.sent();
                            //console.error({ error: e })
                            return [2 /*return*/];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAmountParams = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var path, e_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.getLastInputValuesV2({ input: input, output: output })];
                        case 1:
                            path = _b.sent();
                            return [2 /*return*/, path];
                        case 2:
                            e_4 = _b.sent();
                            if (e_4 === REJECT_PREV_REQUEST_ERROR) {
                                return [2 /*return*/, undefined];
                            }
                            throw new Error(e_4);
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getToken = function (swapToken) {
            var chainId = _this.chainId;
            switch (swapToken.address) {
                case '0x0000000000000000000000000000000000000000':
                    return Ether.onChain(chainId);
                case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
                    return Ether.onChain(chainId);
                case 'NATIVE':
                    return Ether.onChain(chainId);
                default:
                    return new Token(chainId, getAddress(swapToken.address), swapToken.decimals);
            }
        };
        _this.getTokenAddress = function (swapToken) {
            var token = _this.getToken(swapToken);
            if (token.isNative) {
                return _this.chainId === 5 ? WETH.GORLI().contractAddress : WETH.MAINNET().contractAddress;
            }
            return getAddress(swapToken.address);
        };
        _this.getLastInputValuesV2 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, regect) { return __awaiter(_this, void 0, void 0, function () {
                            var currencyIn, currencyOut, isExactIn, values, path, methodName, initParams;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        this.promiseReject = regect;
                                        currencyIn = this.getToken(input.currency);
                                        currencyOut = this.getToken(output.currency);
                                        isExactIn = input.amount ? true : false;
                                        return [4 /*yield*/, this.getSwapInfo({
                                                amount: input.amount || output.amount || '0',
                                                currencyIn: currencyIn,
                                                currencyOut: currencyOut,
                                                isExactIn: isExactIn,
                                                currencyInAddress: this.getTokenAddress(input.currency),
                                                currencyOutAddress: this.getTokenAddress(output.currency),
                                            })];
                                    case 1:
                                        values = _c.sent();
                                        path = (_b = (_a = values === null || values === void 0 ? void 0 : values.trade) === null || _a === void 0 ? void 0 : _a.trade) === null || _b === void 0 ? void 0 : _b.routePath;
                                        methodName = isExactIn ? 'getAmountsOut' : 'getAmountsIn';
                                        initParams = {
                                            inputAmount: values.INPUT.amount,
                                            outputAmount: values.OUTPUT.amount,
                                            methodName: methodName,
                                            plugin: getPlugin({
                                                plugins: SushiswapPlugins.getters,
                                                methodName: methodName,
                                            }),
                                        };
                                        if (isExactIn) {
                                            resolve(__assign(__assign({}, initParams), { params: {
                                                    methodParams: {
                                                        path: path,
                                                        amountIn: values === null || values === void 0 ? void 0 : values.INPUT.amount,
                                                    },
                                                } }));
                                        }
                                        resolve(__assign(__assign({}, initParams), { params: {
                                                methodParams: {
                                                    path: path,
                                                    amountOut: values === null || values === void 0 ? void 0 : values.OUTPUT.amount,
                                                },
                                            } }));
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.setLastInputValuesV2 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, regect) { return __awaiter(_this, void 0, void 0, function () {
                            var values;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.promiseReject = regect;
                                        return [4 /*yield*/, this.getSwapValuesV2({ input: input, output: output })];
                                    case 1:
                                        values = _a.sent();
                                        this.values = values;
                                        resolve(values);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.getSwapValuesV2 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.getSwapValues({
                            input: input,
                            output: output,
                        })];
                });
            });
        };
        _this.getSwapValuesV3 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.getSwapValues({
                            input: input,
                            output: output,
                        })];
                });
            });
        };
        _this.getSwapValues = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, library, account, chainId, currencyIn, currencyOut, isExactIn, blockTimestamp, swapInfo, swapCall, getTradeState, isExactEthInput, methodName, swap;
                var _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!input.currency) {
                                throw new Error('input currency required');
                            }
                            if (!output.currency) {
                                throw new Error('output currency required');
                            }
                            if (!input.amount && !output.amount) {
                                return [2 /*return*/, {
                                        inputAmount: '0',
                                        outputAmount: '0',
                                        state: 'INVALID',
                                        params: undefined,
                                        INPUT: {
                                            currency: undefined,
                                            amount: undefined,
                                        },
                                        OUTPUT: {
                                            currency: undefined,
                                            amount: undefined,
                                        },
                                        trade: undefined,
                                        slippage: undefined,
                                        type: undefined,
                                    }];
                            }
                            _b = this, library = _b.library, account = _b.account, chainId = _b.chainId;
                            currencyIn = this.getToken(input.currency);
                            currencyOut = this.getToken(output.currency);
                            isExactIn = Boolean(input.amount);
                            return [4 /*yield*/, this.getLastBlock()];
                        case 1:
                            blockTimestamp = (_d.sent()).blockTimestamp;
                            return [4 /*yield*/, this.getSwapInfo({
                                    amount: input.amount || output.amount || '0',
                                    currencyIn: currencyIn,
                                    currencyOut: currencyOut,
                                    isExactIn: isExactIn,
                                    currencyInAddress: this.getTokenAddress(input.currency),
                                    currencyOutAddress: this.getTokenAddress(output.currency),
                                })];
                        case 2:
                            swapInfo = _d.sent();
                            return [4 /*yield*/, getSwapCall({ library: library, chainId: chainId, account: account, swapInfo: swapInfo, blockTimestamp: blockTimestamp })];
                        case 3:
                            swapCall = _d.sent();
                            getTradeState = function (stateindex) {
                                switch (stateindex) {
                                    case 3:
                                        return 'VALID';
                                    default:
                                        return 'INVALID';
                                }
                            };
                            isExactEthInput = this.getToken(input.currency).isNative && isExactIn;
                            methodName = getMethodName({
                                isExactInput: isExactIn,
                                isInputNative: input.currency.address === 'NATIVE',
                                isOutputNative: output.currency.address === 'NATIVE',
                                protocol: 'V2',
                            });
                            swap = __assign(__assign({}, swapInfo), { inputAmount: swapInfo.INPUT.amount, outputAmount: swapInfo.OUTPUT.amount, state: getTradeState(((_c = swapInfo === null || swapInfo === void 0 ? void 0 : swapInfo.trade) === null || _c === void 0 ? void 0 : _c.state) || 0), params: { methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params, value: isExactEthInput ? swapCall === null || swapCall === void 0 ? void 0 : swapCall.params.amountIn : undefined }, methodName: methodName, plugin: getPlugin({
                                    plugins: SushiswapPlugins.actions,
                                    methodName: methodName,
                                }) });
                            return [2 /*return*/, swap];
                    }
                });
            });
        };
        _this.getSwapInfo = function (_a) {
            var amount = _a.amount, currencyIn = _a.currencyIn, currencyOut = _a.currencyOut, currencyInAddress = _a.currencyInAddress, currencyOutAddress = _a.currencyOutAddress, isExactIn = _a.isExactIn;
            return __awaiter(_this, void 0, void 0, function () {
                var parsedAmount, parsedAmountString, trade, slippage, trade_1, amountIn_1, amountOut_1, amountIn, amountOut;
                var _b, _c;
                var _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            parsedAmount = weiToCurrency(amount, (_d = (isExactIn ? currencyIn : currencyOut)) !== null && _d !== void 0 ? _d : undefined);
                            parsedAmountString = parsedAmount ? parsedAmount.toSignificant(9) : '0';
                            slippage = getSlippage();
                            if (!(this.chainId !== 5)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getBestTrade({
                                    currencyIn: currencyInAddress,
                                    currencyOut: currencyOutAddress,
                                    amount: parsedAmountString,
                                })];
                        case 1:
                            trade = _g.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.getGoerliTrade({
                                token0: currencyInAddress,
                                token1: currencyOutAddress,
                                token0Decimals: currencyIn.decimals,
                                token1Decimals: currencyOut.decimals,
                                amount: amount,
                                slippage: slippage,
                            })];
                        case 3:
                            trade_1 = _g.sent();
                            amountIn_1 = amount;
                            amountOut_1 = trade_1 === null || trade_1 === void 0 ? void 0 : trade_1.trade.expectedConvertQuote;
                            return [2 /*return*/, (_b = {},
                                    _b[Field.INPUT] = {
                                        currency: currencyIn,
                                        amount: amountIn_1,
                                    },
                                    _b[Field.OUTPUT] = {
                                        currency: currencyOut,
                                        amount: amountOut_1,
                                    },
                                    _b.trade = trade_1,
                                    _b.slippage = slippage,
                                    _b.type = isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT,
                                    _b)];
                        case 4:
                            amountIn = isExactIn ? amount : currencyToWei(((_e = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _e === void 0 ? void 0 : _e.expectedConvertQuote) || '0', currencyIn === null || currencyIn === void 0 ? void 0 : currencyIn.decimals);
                            amountOut = isExactIn
                                ? currencyToWei(((_f = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _f === void 0 ? void 0 : _f.expectedConvertQuote) || '0', currencyOut === null || currencyOut === void 0 ? void 0 : currencyOut.decimals)
                                : amount;
                            return [2 /*return*/, (_c = {},
                                    _c[Field.INPUT] = {
                                        currency: currencyIn,
                                        amount: amountIn,
                                    },
                                    _c[Field.OUTPUT] = {
                                        currency: currencyOut,
                                        amount: amountOut,
                                    },
                                    _c.trade = trade,
                                    _c.slippage = slippage,
                                    _c.type = isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT,
                                    _c)];
                    }
                });
            });
        };
        _this.getGoerliTrade = function (_a) {
            var token0 = _a.token0, token1 = _a.token1, token0Decimals = _a.token0Decimals, token1Decimals = _a.token1Decimals, amount = _a.amount, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var path, amounts, tokenIn, tokenOut, amountOut, minAmount;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.getGoerliPath({ token0: token0, token1: token1 })];
                        case 1:
                            path = _c.sent();
                            if (!path)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.getPathAmountOut({ amountIn: amount, path: path })];
                        case 2:
                            amounts = _c.sent();
                            if (!amounts)
                                return [2 /*return*/];
                            tokenIn = new Token(this.chainId, token0, token0Decimals || 18);
                            tokenOut = new Token(this.chainId, token1, token1Decimals || 18);
                            amountOut = amounts[amounts.length - 1].toString();
                            minAmount = getMinAmount(amountOut, slippage.allowed, tokenOut);
                            return [2 /*return*/, {
                                    trade: {
                                        fromToken: {
                                            chainId: this.chainId,
                                            contractAddress: tokenIn.address,
                                            decimals: tokenIn.decimals,
                                            symbol: tokenIn.symbol || '',
                                            name: tokenIn.name || '',
                                        },
                                        toToken: {
                                            chainId: this.chainId,
                                            contractAddress: tokenOut.address,
                                            decimals: tokenOut.decimals,
                                            symbol: tokenOut.symbol || '',
                                            name: tokenOut.name || '',
                                        },
                                        routePath: path,
                                        baseConvertRequest: (_b = weiToCurrency(amount, tokenIn)) === null || _b === void 0 ? void 0 : _b.toExact(),
                                        minAmountConvertQuote: minAmount.toExact() || '0',
                                        expectedConvertQuote: amountOut,
                                        //...trade,
                                    },
                                    routePath: path,
                                    state: TradeState.VALID,
                                }];
                    }
                });
            });
        };
        _this.getGoerliPath = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var weth, isExist, isToken0WethExist, isWethToken1Exist;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            weth = WETH.GORLI();
                            return [4 /*yield*/, this.isPairExist({ token0: token0, token1: token1 })];
                        case 1:
                            isExist = _b.sent();
                            if (isExist)
                                return [2 /*return*/, [token0, token1]];
                            if (!(!isExist &&
                                getAddress(weth.contractAddress) !== getAddress(token0) &&
                                getAddress(weth.contractAddress) !== getAddress(token1))) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.isPairExist({ token0: token0, token1: weth.contractAddress })];
                        case 2:
                            isToken0WethExist = _b.sent();
                            return [4 /*yield*/, this.isPairExist({ token0: weth.contractAddress, token1: token1 })];
                        case 3:
                            isWethToken1Exist = _b.sent();
                            if (isToken0WethExist && isWethToken1Exist)
                                return [2 /*return*/, [token0, weth.contractAddress, token1]];
                            _b.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * Returns the best v2+v3 trade for a desired swap.
         * @param tradeType whether the swap is an exact in/out
         * @param amountSpecified the exact amount to swap in/out
         * @param otherCurrency the desired output/payment currency
         */
        _this.getBestTrade = function (_a) {
            var currencyIn = _a.currencyIn, currencyOut = _a.currencyOut, amount = _a.amount;
            return __awaiter(_this, void 0, void 0, function () {
                var library, clientSORTradeObject, tradeObject, lastTrade, state, trade;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            library = this.library;
                            return [4 /*yield*/, getClientSideSmartOrderRouterTrade({
                                    library: library,
                                    account: this.account,
                                    chainId: this.chainId,
                                    currencyIn: currencyIn,
                                    currencyOut: currencyOut,
                                    amount: amount,
                                })];
                        case 1:
                            clientSORTradeObject = _b.sent();
                            tradeObject = clientSORTradeObject;
                            lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade;
                            if (!tradeObject)
                                return [2 /*return*/];
                            state = tradeObject.state, trade = tradeObject.trade;
                            // If the trade is in a settled state, return it.
                            if (state === TradeState.INVALID)
                                return [2 /*return*/, INVALID_TRADE];
                            if ((state !== TradeState.LOADING && state !== TradeState.SYNCING) || trade)
                                return [2 /*return*/, tradeObject
                                    // If the trade currencies have switched, consider it stale - do not return the last trade.
                                ];
                            // If the trade currencies have switched, consider it stale - do not return the last trade.
                            return [2 /*return*/, { state: state, trade: lastTrade }];
                    }
                });
            });
        };
        return _this;
    }
    return Sushiswap;
}(Config));
export { Sushiswap };
